import { Navigate, Route, Routes } from 'react-router-dom'
import { Login } from '../components/login/Login'
import { Unsubscribe } from './Unsubscribe'

export const PublicRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="*" element={<Navigate to={'/login'} />} />
        </Routes>
    )
}